import { render, staticRenderFns } from "./common-delete-dialog.vue?vue&type=template&id=a99283d2"
import script from "./common-delete-dialog.vue?vue&type=script&lang=js"
export * from "./common-delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./common-delete-dialog.vue?vue&type=style&index=0&id=a99283d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports